module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/slideCaptcha/assets/fail.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/slideCaptcha/assets/fail.png
// module id = 1311
// module chunks = 438